import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { resetCurrentAccount } from '../../store/shared/accountSlice';
import { logoutUser } from '../../store/shared/userSlice';
import { getOidcClientRoot } from '../../env-vars';

function SignoutCallback() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(resetCurrentAccount());
    dispatch(logoutUser());

    window.location.replace(getOidcClientRoot());
  }, []);

  return <h1 className="p-5">Signing out...</h1>;
}

export default SignoutCallback;
